export default __webpack_public_path__ + "static/media/not-found.fc106b66.png";